module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/main-visual-text-22d466df014a835bfd1f9cc1a35fa7fe.svg";